











































































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import AbpBase from '../../lib/abpbase'
    import OrderManagement from '../../store/entities/ordermanagement'
    import moment from 'moment';
    @Component
    export default class CreateOrderManagement extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        ordermanagement:OrderManagement=new OrderManagement();
      
          get companyinformations(){
            
             
            return this.$store.state.ordermanagement.companyinformations;
        }
          get wastetypes(){
            
              return this.$store.state.ordermanagement.wastetypes;
        }
        get  ntime(){
           
          return this.currentTime();

         

        }
            async getCompanyInformation_All(){

              await this.$store.dispatch({
                type:'ordermanagement/getCompanyInformation',
                
            })
        }

        get  disposeInfo(){
           
              let isd=  this.$store.state.ordermanagement.isdispose;
               var list= this.$store.state.ordermanagement.ordertype;
                var lt=[];
               if(isd){
                      
                      for(var i=0;i<list.length;i++){
                         if(i==2){
                           
                             lt.push(list[i])
                         }

                      }
                      return lt;
                
               }else{

                return this.$store.state.ordermanagement.ordertype
               }
             
                


        }
        
    
        save(){
           
            if(this.ordermanagement.type==1){
                this.ordermanagement.status=2;
            }
         
             
            
            (this.$refs.ordermanagementForm as any).validate(async (valid:boolean)=>{
                 console.log(  this.ordermanagement.ordertime )
                if(valid){
                    await this.$store.dispatch({
                        type:'ordermanagement/create',
                        data:this.ordermanagement
                    });
                    (this.$refs.ordermanagementForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
        }
        cancel(){
            (this.$refs.ordermanagementForm as any).resetFields();
            this.$emit('input',false);
             this.ordermanagement.ordertime=new Date(this.currentTime()) ;
        }
        visibleChange(value:boolean){
             this.ordermanagement.ordertime=new Date(this.currentTime()) ;
                  this. ordermanagement.type=this.$store.state.ordermanagement.type;
             if(  this. ordermanagement.type==2){
                this. ordermanagement.status=1;
              }else{

                this. ordermanagement.status=2;
              }
            
              
             if(!value){
                this.$emit('input',value);
                
           
            }else{
                
               // this.ordermanagement=Util.extend(true,{},this.$store.state.ordermanagement.editOrderManagement);
            }
        }


        
        validatePassCheck = (rule:any, value:any, callback:any) => {
            if (!value) {
                callback(new Error(this.L('ConfirmPasswordMsg')));
               
                callback(new Error(this.L('ConfirmPasswordNotMatch')));
            } else {
                callback();
            }
        };
        ordermanagementRule={
            // cid:[{type:'number',required:true,message:this.L('FieldIsRequired',undefined,this.L('CompanyinformationName')),trigger: 'change'}],
             wtid:[{type:'number',required:true,message:this.L('FieldIsRequired',undefined,this.L('WasteType')),trigger: 'change'}],
             status:[{type:'number',required:true,message:this.L('FieldIsRequired',undefined,this.L('OrderStatus')),trigger: 'change'}],
             operators:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('OrderOperators')),trigger: 'blur'}],
             weight:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('OrderWeight'))}],
             ordertime:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('OrderTime'))}],
            // orderno:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Orderno'))}],
        }
        isActiveChange(val:string){
                
          
        }
        isOrderType(val:string){
        if(val=="1"){
           
              this.$store.state.ordermanagement. statusselected=2; 
              this.$store.state.ordermanagement. isShowStatus=false;
               
                

        }else{
            
               this.$store.state.ordermanagement. statusselected=1; 
               this.$store.state.ordermanagement. isShowStatus=true;
             

        }
         
        }
        onchangtime(val){

         console.log(val)
          var tt=  this. currentTime(val)
          this. ordermanagement.ordertime=new Date(tt);

        }
        currentTime(val=null) {
              let nowDate = new Date();
            if(val!=null){
                nowDate=new Date(val)

            }
        
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
        hours: nowDate.getHours(),
        minutes: nowDate.getMinutes(),
        seconds: nowDate.getSeconds(),
      };      
      let newmonth = date.month > 10 ? date.month : "0" + date.month;
      let newday = date.date > 10 ? date.date : "0" + date.date;
      let newminutes = date.minutes < 10 ? "0" + date.minutes : date.minutes;
      let newseconds = date.seconds < 10 ? "0" + date.seconds : date.seconds;
      // 我需要的时间格式为 "yyyy-MM-dd HH:mm:ss" 有不一样的自己拼别的，都是字符串拼接
      let newTime =
        date.year +
        "-" +
        newmonth +
        "-" +
        newday +
        " " +
        date.hours +
        ":" +
        newminutes +
        ":" +
        newseconds;
        return newTime;
}
created() {
   
     
   
   this.ordermanagement.type=this.$store.state.ordermanagement.type;
   
   if( this.ordermanagement.type==2){
     this. ordermanagement.status=this.$store.state.ordermanagement.status;
   }
}

        
    }
